import { render, staticRenderFns } from "./about_hm_modal.vue?vue&type=template&id=36069d9e&lang=pug&"
import script from "./about_hm_modal.vue?vue&type=script&lang=coffee&"
export * from "./about_hm_modal.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports